var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white rounded-tl-md rounded-tr-md"
  }, [_c('div', {
    staticClass: "flex items-center tab shadow-border-b"
  }, _vm._l(_vm.tabList, function (tab) {
    return _c('div', {
      key: tab.title,
      staticClass: "px-6 py-3 relative cursor-pointer",
      class: [tab.isActive ? 'text-neutral-700 font-medium active' : 'text-neutral-500'],
      on: {
        "click": function ($event) {
          return _vm.selectTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.title) + " ")]);
  }), 0), _c('div', {
    staticClass: "content"
  }, [_c(_vm.selectedTab.content, {
    tag: "component"
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }